import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Claims API
export const claimsAPI = {
  create: (data) => api.post('/claims', data),
  getAll: (params = {}) => api.get('/claims', { params }),
  getAllForBroker: () => api.get('/claims', { params: { show_all: true } }),
  getById: (id) => api.get(`/claims/${id}`),
  update: (id, data) => api.put(`/claims/${id}`, data),
};

// Documents API
export const documentsAPI = {
  upload: (claimId, file) => {
    const formData = new FormData();
    formData.append('claim_id', claimId);
    formData.append('file', file);
    return api.post('/documents/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getByClaim: (claimId) => api.get(`/documents/${claimId}`),
};

// Messages API
export const messagesAPI = {
  create: (data) => api.post('/messages', data),
  getByClaim: (claimId) => api.get(`/messages/${claimId}`),
};

// Notifications API
export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
};

// Users API
export const usersAPI = {
  getAll: () => api.get('/users'),
  getBrokers: () => api.get('/users/brokers'),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
};

// Profile API
export const profileAPI = {
  update: (data) => api.put('/auth/profile', data),
  resetPassword: (email, newPassword) => api.post('/auth/reset-password', { email, new_password: newPassword }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
};

// Analytics API
export const analyticsAPI = {
  getDashboard: () => api.get('/analytics/dashboard'),
};
